<template>
  <div class="home-wrapper" ref="home-wrapper" :class="{ 'full-content': isFullContent }">
    <Header
      class="h-14 md:h-15 shadow-top nav-wrapper z-5"
      :class="{
        'full-content': isFullContent,
      }"
    >
      <MainHeader
        v-if="hasCurrentUser"
        key="main-header-logged-in"
        :class="{'p-4': isFullContent }"
        :isTemplateSearchVisible="isTemplateSearchVisible"
      />
      <MainHeader
        v-else
        key="main-header-logged-out"
        :class="{'p-4': isFullContent }"
        :isTemplateSearchVisible="isTemplateSearchVisible"
        :isShownUserIconButton="false"
      >
        <template #language-selection>
          <MultipleLanguage class="custom-language ml-auto" />
        </template>
        <template #notifications>
          <span></span>
        </template>
        <template #upgrade-button>
          <span></span>
        </template>
        <template #user-icon-button>
          <span></span>
        </template>
      </MainHeader>
    </Header>
    <div class="main-content">
      <Sidebar
        class="home-side-bar"
        :isSideBarVisible="isSideBarVisible"
        :ignoreSideBarMounted="true"
      >
        <template v-if="!hasCurrentUser" #control-section>
          <span></span>
        </template>
        <template v-if="!hasCurrentUser" #profile>
          <span></span>
        </template>
        <template v-if="!hasCurrentUser" #mobile-only-section>
          <span></span>
        </template>
      </Sidebar>
      <div class="backdrop" :class="{show: isSideBarBackDropVisible}" @click="hideMenuMobile" />
      <div
        class="router-view-content"
        :class="{
          'full-content': isFullContent,
          'ml-16': hasOnboardingV3,
          'hide': !isRouterViewContentShowing,
          'ml-0': isInlineLoaderVisible,
          'eu': isEURegion
        }"
      >
        <ReportPagePublic />
      </div>
    </div>
    <CtaBar v-if="!hasCurrentUser" class="bg-secondary-100 p-5 flex-wrap">
      <template #tagline>
        <h3 class="text-primary-50">
          {{ ctaMessage }}
        </h3>
      </template>
    </CtaBar>
  </div>
</template>
<script>
import { isEmpty } from 'lodash'
import { mapMutations } from 'vuex'
import Home from '@/components-v2/home/Home.vue'
import ReportPagePublic from '@/components-v2/presentation-report/ReportPagePublic.vue'
import Sidebar from '@/components-v2/common/sidebar/SideBar.vue'
import MultipleLanguage from '@/components-v2/multiple-language/MultipleLanguage.vue'
import CtaBar from '@/components-v2/common/cta/CtaBar.vue'

export default {
  components: {
    ReportPagePublic,
    Sidebar,
    MultipleLanguage,
    CtaBar,
  },
  // extends to use logic from Home
  extends: Home,
  computed: {
    hasCurrentUser() {
      return this.currentUser?.id
    },
    ctaMessage() {
      return this.$i18nPresenter.t('Get started with AhaSlides to create, share, and collaborate on interactive presentations.')
    },
  },
  methods: {
    ...mapMutations(['setCurrentUser']),
    async getCurrentUserAction() {
      if (!isEmpty(this.currentUser)) return this.currentUser
      // mock user to avoid error when user is not logged in
      // many logic in Home which depends on currentUser but i don't wanna touch that
      const mockUser = {}
      this.setCurrentUser(mockUser)
      return mockUser
    },
  },
}
</script>
<style lang="scss" scoped>
.home-wrapper {
  max-height: -webkit-fill-available; // fix height in ios safari (with address bar)
  @apply flex flex-col h-screen;
  &.full-content {
    .main-content {
      @apply pt-0;
    }
  }

  .main-content {
    @apply flex-grow bg-primary-50 pt-15;
    &.is-onboarding::v-deep {
      .aha-invitation-notification, .aha-public-announcement {
        z-index: 4 !important;
        @apply lg:-left-18 -left-8;
        width: 102vw;
      }
      .aha-invitation-notification .global-notification-bar {
        display: flex;
        width: 100%;
        justify-content: center;
        padding-left: 1.75rem;
      }
    }
    &.is-loading-content {
      @apply overflow-hidden;
    }
  }
}

.nav-wrapper {
  @apply fixed w-full top-0;
  z-index: 20;
  &.full-content {
    position: static;
  }
}

.backdrop {
  height: 100%;
  width: 100%;
  background-color: #00000060;
  position: fixed;
  z-index: 21;
  visibility: hidden;
  top: 0;
  opacity: 0;
  transition: .3s ease;
}

.backdrop.show {
  opacity: 1;
  visibility: visible !important;
}

.router-view-content {
  @apply bg-primary-50 h-auto flex-grow;
  @media screen and (min-width: 1024px){
    margin-left: 14rem;
  }
  &.ml-16 {
    @apply lg:ml-16 ml-6;
  }
  &.ml-0 {
    margin-left: 0 !important;
  }
  &.full-content {
    @apply bg-base-0 lg:ml-0;
  }
  &.early-bird-registration {
    @apply bg-primary-50;
  }
  &.hide {
    @apply opacity-0;
  }
  &.eu {
    @media screen and (min-width: 1024px){
      margin-left: 14rem;
    }
  }
}

.inline-loader__wrapper {
  @apply h-full w-full flex items-center justify-center overflow-hidden;
}

.wrapper-participant-limit{
  position: sticky;
  top:60px;
  z-index: 21;
}

.custom-language {
  position: unset!important;

  &::v-deep {
    .aha-dropdown-menu-ai {
      min-width: 120px;
      max-height: 300px;
    }
  }
}
</style>
